// extracted by mini-css-extract-plugin
module.exports = {"label":"Login_label__3hJ3d","input":"Login_input__2PBF2","button":"Login_button__ru-22"};